export default (function () {
	function init(el) {
		if ($(el).length > 0) {
			const forms = $(el).find('.variations_form');

			$(el).find('.js-product-link').each(updateLink);
			$(forms).on('change', e => {
				const link = $(e.target).closest('.js-single-product').find('.js-product-link');
				updateLink(null, link);
			});
		}
	}

	function updateLink(i, el) {
		const productForm = $(el).closest('.js-single-product').find('.variations_form');
		const attributes = getAttributes(productForm);
		const params = getUrlParams(attributes);

		setLink(el, params);
	}

	function setLink(linkEl, params) {
		if (!params) return;

		let baseUrl = $(linkEl).data('href');

		if (!baseUrl) {
			baseUrl = $(linkEl).attr('href');
			$(linkEl).data('href', baseUrl);
		}

		$(linkEl).attr('href', `${baseUrl}?${params}`);
	}

	function getUrlParams(attributes) {
		return new URLSearchParams(attributes).toString();
	}

	function getAttributes(form) {
		let attributes = {};

		$(form).find('input').each((i, input) => {
			if (input.checked) {
				attributes[$(input).data('attribute_name')] = $(input).val();
			}
		});

		return attributes;
	}

	return {init};
})();